import * as React from "react";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import { isNullOrEmpty } from "../../../../../../../../react-core/Utils/Arrays";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SourceType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SourceType";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { MoneyOrPercentage } from "../../../../../../../../Wrap/Models/Models/Shared/MoneyOrPercentage";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { AdviserChargesContents } from "../../../../Common/AdviserCharges/Resource/Contents";
import { ChargesHelper } from "../../../../Common/Helpers/ChargesHelper";

interface IChargesCopyOptionProps extends IProcessComponentProps {}

interface IChargesCopyOptionState {}

export class ChargesCopyOption extends ProcessComponent<IChargesCopyOptionProps, IChargesCopyOptionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        super.componentDidMount();
        const { data, onChange } = this.props;
        if (isNullOrEmpty(data.ISAQuote.ChargesExtraInfo?.CopyChargesFromOtherWizard)) {
            if (!data.ISAQuote.ChargesExtraInfo) {
                data.ISAQuote.ChargesExtraInfo = { CopyChargesFromOtherWizard: false };
            } else {
                data.ISAQuote.ChargesExtraInfo.CopyChargesFromOtherWizard = false;
            }
        }
        onChange(data);
    }

    copyCharges(v: boolean) {
        const { data, onChange } = this.props;
        data.ISAQuote.ChargesExtraInfo.CopyChargesFromOtherWizard = v;
        if (v) {
            if (ChargesHelper.displayIAC(data.ISAQuote, SubAccountType.StocksIsa)) {
                const iac = {...data.PensionQuote.InitialAdviserCharge};
                iac.SourceType = SourceType.WrapCash;
                data.ISAQuote.InitialAdviserCharge = iac;
            }
            const oac = {...data.PensionQuote.OngoingAdviceCharge};
            oac.SourceType = SourceType.WrapCash;
            data.ISAQuote.OngoingAdviceCharge = oac;
        } else {
            data.ISAQuote.InitialAdviserCharge = this.emptyPercentageOrMoney();
            data.ISAQuote.OngoingAdviceCharge = this.emptyPercentageOrMoney();
        }
        onChange(data);
    }

    emptyPercentageOrMoney(): MoneyOrPercentage {
        return {
            Type: null,
            Money: { Amount: null, Currency: CurrencyCode.GBP },
            Percentage: null,
            Frequency: null,
            SourceType: null,
        };
    }

    public render(): JSX.Element {
        const sippProvided = ChargesHelper.chargesProvided(this.props.data.PensionQuote);
        if (!sippProvided) {
            return null;
        }
        return (
            <>
                <RadiosEditor
                    cssWrapper="rg-150 mb-24"
                    label={AdviserChargesContents.CopyFromabrdnSipp}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    selected={this.props.data?.ISAQuote?.ChargesExtraInfo?.CopyChargesFromOtherWizard}
                    onChange={(v) => this.copyCharges(v)}
                />
            </>
        );
    }
}
